import { User } from "./../../shared/models/user.model";
import { FileAttachment } from "../../shared/models/file-attachment.model";

export class ActionDetails {
  SourceText: string;
  Source: number;
  SourceId: number;
  ActionId: number;
  ActionOwnerId: number;
  ActionPartyId: number;
  ActionVerifierId: number;
  ActionDetails: string;
  Priority: number = 2;
  AssignedBy: string;
  CreatedBy: number;
  CreatedDate: Date;
  TargetDate: Date = new Date();
  StatusId: number;
  StatusText: string;
  ActionAssignedOn: string;
  ActionDueDate: string;
  ActionPriority: string;
  ObservationSubmitDate: string;
  Designation: string;
  displayActionListErrorMessages: any = {
    ActionDetails: false,
    ActionOwner: false,
    ActionParty: false,
    ActionVerifier: false,
    CorrectActionOwner: false,
    CorrectActionParty: false,
    CorrectActionVerifier: false,
    TargetDate: false,
    Priority: false
  };
  selectedActionOwner: User;
  selectedActionParty: User;
  selectedActionVerifier: User;
}

export class AssignActionPost {
  ActionId: number = 0;
  ActionParty: User = new User();
  Action: string = "";
  ActionOwnerId: number = 0;
  Priority: number = 2;
  TargetDate: Date = new Date();
  ShowActionErrorMessage: boolean = false;
  ShowActionOwnerErrorMessage: boolean = false;
  ShowActionPartyErrorMessage: boolean = false;
  ShowActionVerifierErrorMessage: boolean = false;
  ShowPriorityErrorMessage: boolean = false;
  ShowTargetErrorMessage: boolean = false;
  ActionOwner: User = new User();
  ActionPartyId: number = 0;
  selectedAction: string;
  SelectedAction: boolean;
  selectedActionParty: User = new User();
  selectedActionVerifier: User = new User();
  UnitId: number;
  Status: string;
  Files: any[] = [];
  FilesPreview: any[] = [];
  ProcessId: number;
}

export class AssignActionForSourcePost {
  ActionId: number = 0;
  Action: string = "";
  ActionOwnerId: number = 0;
  ActionPartyId: number = 0;
  Priority: number = 2;
  TargetDate: Date = new Date();
  ShowActionErrorMessage: boolean = false;
  ShowActionOwnerErrorMessage: boolean = false;
  ShowActionPartyErrorMessage: boolean = false;
  ShowPriorityErrorMessage: boolean = false;
  ShowTargetErrorMessage: boolean = false;
  ShowActionVerifierErrorMessage: boolean = false;
  ActionOwner: User = new User();
  selectedActionParty: User = new User();
  selectedActionVerifier: User = new User();
  ActionParty: User = new User();
  Status: string = "Open";
  ShowActionbuttons: boolean = false;
  selectedAction: string;
  SelectedAction: boolean;
  UnitId: number;
  ProcessId: number;
  Files: any[] = [];
  FilesPreview: any[] = [];
}
export class ActionTrackerPermissionDetails {
  public ACT_Add: boolean;
  public ACT_Add_Unit: boolean;
  public ACT_Admin_Unit: boolean;
  public ACT_Admin: boolean;
  public ACT_View_Unit: boolean;
  public ACT_View: boolean;
  public ACT_Action_Party: boolean;
  public ACT_Action_Verifier: boolean;
  public ACT_Action_Owner: boolean;
  public ACT_Own: boolean;
}
